import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import type { PriceImportRun } from './types';

const endpoint = 'ums/v1/cms/supplier-price-imports';
export const priceImportsEndpointIdentifier = endpoint;

interface ResponseData {
  data: PriceImportRun[];
}

type TData = ResponseData;
type TError = AxiosError;
type TQueryKey = [typeof endpoint, { supplierId?: number }];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetPriceImportRunsApi(supplierId?: number, options?: Options): ReturnType {
  const toast = useCustomToast();
  const isLoggedIn = useIsLoggedIn();

  const queryFn = async () => {
    try {
      const { data } = await http.get(endpoint, { params: supplierId ? { supplierId } : undefined });
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({ description: error.response.data.message, status: 'error' });

      throw error;
    }
  };

  return useQueryWrapper([endpoint, { supplierId }], queryFn, { enabled: isLoggedIn, ...options });
}
